import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import Sidebar from '../Sidebar/Sidebar';

const MakeAdmin = () => {
    const { register, errors, handleSubmit } = useForm();

    const onSubmit = data => {
        fetch('https://rocky-plains-35683.herokuapp.com/addAdmin', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(data => {
                if (data) {
                    alert('your Add Admin successfully')
                }
            })
    };

    return (

        <section>

            <div className="row">
                <div className="col-md-2 col-sm-6 col-12">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-5 col-sm-12 col-12 d-flex justify-content-center">
                    <div style={{ margin: '30px', borderRadius: '20px', backgroundColor: '#FFFFFF', fontWeight: 'bold' }}>

                        <div className="registerForm">
                            <h4>New Admin email</h4>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <input name="email" placeholder="New Admin Email" ref={register({ required: true })} /><br />
                                {errors.email && <span>your email is required<br /></span>}

                                <input className="submitBtn" type="submit" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default MakeAdmin;